import React, { Component } from "react";
import Rendersidebar from "../Components/Sidebar/sidebar";
import {
  SIDE_NAV_ITEMS,
  sliderData,
  API_URLS,
} from "../api-constant";
import NewNavBar from "../Components/NavBar/Navbar";
import ResponsiveSidebar from "../Components/Sidebar/Responsive/SideBar";
import dashboardIcon from "../../images/new-images/dark-nav-icon.png";
import assessmentHeaderIcon from "../../images/my Assessment.png";
import DashboardSummary from "./Dashboard-summary/dashboard-summary";
import Myassessments from "./My-assessments/my-assessment";
import Myinvitations from "./My-Invitations/My-Invitations";
import axios from "axios";
import addAccessTokenToUrl from "../Utils/Axios/addTokenToUrl";
import { withRouter } from "react-router";
import NavBar from "../../_components/common/Navbar";
import { toast } from "react-toastify";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.onPopState = this.onPopState.bind(this);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[0].id,
      sidebarOpen: false,
      receivedTab: true,
      sentTab: false,
      isPopOverOpenAssessmentId: false,
      isPopOverVisible: false,
      overlayIsVisible: false,
      newAssessmentCount: "",
      pendingAssessmentCount: "",
      completedAssessmentCount: "",
      myInvitationsCount: "",
      editModal: false,
      deleteModal: false,

      dropDownOptions: [],
      isChecked: false,
      isDisabled: true,
      respondentEmail: "",
      respondentRelationship: "",
      enableNotification: false,
      userAssessmentDetails: [],
      loading: true,
      receivedInvitations: [],
      sentRespondants: [],
      respondentInvitationsModal: false,


      getRespondantStatus: [],
      getUrlString: "",
      minRespondants: "",
      batchMinRespondants: "",
      successMessage: "",
      respondantEmail: "",
      respondantUserAssessmentId: "",
      respondantIndividualId: "",
      collapseID: null,
      filteredSentRespondants: null,
      orgId: "",
      sellerId: "",
      reportNotification: false,
      filteredUserAssessmentCount: [],
      notify: false,
    };
  }

  accessorGroupApi = () => {
    const sellerId = this.state.sellerId;
    const orgId = this.state.orgId;
    /* accessor group api */
    axios
      .get(
        addAccessTokenToUrl(
          API_URLS.Respondent_Relation_Accessor_Dropdown({ sellerId, orgId })
        )
      )
      .then((response) => {
        this.setState({
          dropDownOptions: response.data.organisation_assessor_group_list,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  componentDidMount() {

    const { history } = this.props;

    if (window.location.pathname === '/admin/app/dashboard') {
      history.push('/admin/app/dashboard');
      window.onpopstate = () => {
        history.push('/admin/app/dashboard');
      };
    }


    if (window.location.pathname === '/new/app/dashboard') {
      history.push('/new/app/dashboard');
      window.onpopstate = () => {
        history.push('/new/app/dashboard');
      };
    }



    /* show notification */
    const getNotificationStatus = localStorage.getItem("Show Notification");
    const isSignedUp = localStorage.getItem("is_sign_up_completed");
    if (!getNotificationStatus && !isSignedUp) {
      setTimeout(() => {
        this.setState({
          enableNotification: true,
          notify: true,
        });
      }, 3000);
    }
    localStorage.setItem("Show Notification", true);
    localStorage.setItem("is_sign_up_completed", true);
    /* handle api calls */


    axios
      .get(addAccessTokenToUrl("/assessments/user/active/assessments/"), {
        params: {
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      })

      .then((response) => {
        if (response.data && response.data.user_assessments[0]) {
          localStorage.setItem(
            "participant_id",
            response.data.user_assessments[0].participant__id
          );
        }


        response.data.user_assessments.map((getRespondants) => {
          {
            this.setState({
              batchMinRespondants: getRespondants.batch__min_respondent,
            });
            getRespondants.respondents.map((i) => {
              this.setState({
                getRespondantStatus: i,
              });
            });
          }
        });

        const filteredData = [];
        response.data.user_assessments.map((element) => {
          element.respondents.filter((filteredElement) => {
            if (
              filteredElement.assessment_status__status_name === "Completed"
            ) {
              return filteredData.push(filteredElement);
            }
          });
        });
        const getOnlyAssessmentStatus = filteredData.map((i) => {
          return i.assessment_status__status_name;
        });

        const filteredSentRespondants = response.data.user_assessments[0];

        this.setState(
          {
            newAssessmentCount: response.data.new_assessements,
            pendingAssessmentCount: response.data.pending_assessments,
            orgId: filteredSentRespondants
              ? filteredSentRespondants.organisation
              : "",
            sellerId: filteredSentRespondants
              ? filteredSentRespondants.seller
              : "",
            completedAssessmentCount: response.data.completed_assessments,
            myInvitationsCount: response.data.my_inivations,
            userAssessmentDetails: response.data.user_assessments,
            receivedInvitations: response.data.my_inivation,
            sentRespondants: response.data.user_assessments,
            minRespondants: getOnlyAssessmentStatus,
            loading: false,

          },
          () => {
            this.accessorGroupApi();
          }
        );
      })
      .catch((error) => {
        console.error(error);
        this.setState({ loading: false });

      });
  }

  componentWillUnmount() {
    // Cleanup
    window.onpopstate = null;
  }

  onPopState() {
    window.history.go(1);
  }

  handleReceivedTab = () => {
    this.setState({
      receivedTab: true,
      sentTab: false,
    });
  };
  handleSentTab = () => {
    this.setState({
      sentTab: true,
      receivedTab: false,
    });
  };

  handleAssessmentPopOver = (assessmentId) => {
    this.setState({
      isPopOverOpenAssessmentId: assessmentId,
      overlayIsVisible: true,
    });
  };

  handleClosePopOver = () => {
    this.setState({
      isPopOverOpenAssessmentId: false,
      overlayIsVisible: false,
    });
  };

  handleInvitationPopOver = () => {
    this.setState({
      isPopOverVisible: true,
      overlayIsVisible: true,
    });
  };

  handleCloseInvitationsPopOver = () => {
    this.setState({
      isPopOverVisible: false,
      overlayIsVisible: false,
    });
  };

  handleModalClose = () => {
    this.setState({
      editModal: false,
      deleteModal: false,
      respondentInvitationsModal: false,
      reportNotification: false,

      overlayIsVisible: false,
    });
    localStorage.setItem("Modal Name", false);
  };

  handleEditModal = (email, relation, uid, rid, gid) => {
    this.setState({
      editModal: true,
      respondentEmail: email,
      respondentRelationship: relation,
      assessmentUserId: uid,
      relationShipId: rid,
      accessorGroupId: gid,
    });
  };

  handleDeleteModal = (email, respUserId, respRespondantId) => {
    this.setState({
      deleteModal: true,
      respondentEmail: email,
      respondantUserAssessmentId: respUserId,
      respondantIndividualId: respRespondantId,
    });
  };

  handleInvitationsModal = () => {
    this.setState({
      respondentInvitationsModal: true,
    });
  };

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };

  handleDropdownOptions = (dropDownId) => {
    this.setState({
      setDropdownValue: dropDownId,
    });
  };
  handleReminder = (idUser, emailRespondants, idRespondants) => {
    const userType = localStorage.getItem('usertype') || "";

    axios
      .post(
        addAccessTokenToUrl("/assessments/send/email/remainder/indivisual/"),
        {
          assessment_id: idUser,
          respondent_id: idRespondants,
        }
      )
      .then((response) => {
        if (userType.includes("organisation_admin") || userType.includes("seller_admin")) {
          toast.success(response.data.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 1500,
          });
        }

        this.setState({
          successMessage: response.data.message,
          enableNotification: true,
          respondentEmail: emailRespondants,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleDeleteRequest = (uid, rid) => {

    axios
      .post(
        addAccessTokenToUrl("/assessments/user/respondent/remove/assessment/"),
        {
          user_assessment_id: uid,
          respondent_id: rid,
        }
      )
      .then((response) => {
        this.setState({
          successMessage: response.data.message,
          enableNotification: true,
          deleteModal: false,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };

  toggleCollapse = (collapseID) => {
    if (this.state.collapseID === collapseID) {
      this.setState({
        collapseID: null,
      });
    } else {
      this.setState({
        collapseID: collapseID,
      });
    }
  };

  handleEditModalSubmit = (userid, respondantId, relationId) => {



    axios
      .post(
        addAccessTokenToUrl(
          `/assessments/user/respondent/edit/assessment/relation/${userid}/${respondantId}/`
        ),
        {
          accessor_group_id: this.state.setDropdownValue,
        }
      )
      .then((response) => {
        this.setState({
          updateMessage: response.data.message,
        });

        if (response.data.status) {
          axios
            .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
            .then((response) => {
              this.setState({
                sentRespondants: response.data.user_assessments,
                enableNotification: true,
                editModal: false,
                respondentInvitationsModal: false,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleMouseEnter = () => {
    const getModal = localStorage.getItem("Modal Name");
    if (!getModal) {
      this.setState({
        reportNotification: true,
        overlayIsVisible: true,
      });
      localStorage.setItem("Modal Name", true);
    }
  };

  handleCloseNotification = () => {
    this.setState({
      enableNotification: false,
    });
  };

  render() {
    const fullName = localStorage.getItem("full_name");
    const shortName = localStorage.getItem("short_name");
    const userType = localStorage.getItem("usertype");



    const isNameEmpty = !fullName || fullName === "null";
    const isShortNameEmpty = !shortName || shortName === "null";

    if (isNameEmpty || isShortNameEmpty) { // Using || (OR) operator here
      this.props.history.push("/new/app/createprofile");
    }
    return (
      <React.Fragment>
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? (
          <NavBar />
        ) : (
          <NewNavBar
            enableNotification={this.state.enableNotification}
            handleNotification={this.handleNotification}
            successMessage={this.state.successMessage}
            respondentEmail={this.state.respondentEmail}
            updateMessage={this.state.updateMessage}
            notify={this.state.notify}
            handleCloseNotification={this.handleCloseNotification}
          />
        )}

        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <Rendersidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
          />
        ) : null}
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? null : (
          <ResponsiveSidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            sidebarOpen={this.state.sidebarOpen}
            onSetSidebarOpen={this.onSetSidebarOpen}
          />
        )}

        <DashboardSummary
          dashboardIcon={dashboardIcon}
          assessmentHeaderIcon={assessmentHeaderIcon}
          newAssessmentCount={this.state.newAssessmentCount}
          pendingAssessmentCount={this.state.pendingAssessmentCount}
          completedAssessmentCount={this.state.completedAssessmentCount}
          myInvitationsCount={this.state.myInvitationsCount}
          sentRespondants={this.state.sentRespondants}
          userAssessmentDetails={this.state.userAssessmentDetails}
        />
        <Myassessments
          userAssessmentDetails={this.state.userAssessmentDetails}
          isPopOverOpenAssessmentId={this.state.isPopOverOpenAssessmentId}
          handleAssessmentPopOver={this.handleAssessmentPopOver}
          handleClosePopOver={this.handleClosePopOver}
          overlayIsVisible={this.state.overlayIsVisible}
          sliderData={sliderData}
          collapseID={this.state.collapseID}
          toggleCollapse={this.toggleCollapse}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          reportNotification={this.state.reportNotification}
          handleModalClose={this.handleModalClose}
          loading={this.state.loading}
        />
        <Myinvitations
          receivedTab={this.state.receivedTab}
          sentTab={this.state.sentTab}
          handleReceivedTab={this.handleReceivedTab}
          handleSentTab={this.handleSentTab}
          isPopOverVisible={this.state.isPopOverVisible}
          handleInvitationPopOver={this.handleInvitationPopOver}
          handleCloseInvitationsPopOver={this.handleCloseInvitationsPopOver}
          overlayIsVisible={this.state.overlayIsVisible}
          editModal={this.state.editModal}
          deleteModal={this.state.deleteModal}
          handleModalClose={this.handleModalClose}
          handleEditModal={this.handleEditModal}
          handleDeleteModal={this.handleDeleteModal}
          respondentEmail={this.state.respondentEmail}
          respondentRelationship={this.state.respondentRelationship}
          receivedInvitations={this.state.receivedInvitations}
          sentRespondants={this.state.sentRespondants}
          handleInvitationsModal={this.handleInvitationsModal}
          respondentInvitationsModal={this.state.respondentInvitationsModal}
          dropDownOptions={this.state.dropDownOptions}
          isChecked={this.state.isChecked}
          isDisabled={this.state.isDisabled}
          getRespondantStatus={this.state.getRespondantStatus}
          getUrlString={this.state.getUrlString}
          minRespondants={this.state.minRespondants}
          batchMinRespondants={this.state.batchMinRespondants}
          handleReminder={this.handleReminder}
          respondantUserAssessmentId={this.state.respondantUserAssessmentId}
          respondantIndividualId={this.state.respondantIndividualId}
          handleDeleteRequest={this.handleDeleteRequest}
          sentRespondantsId={this.state.sentRespondantsId}
          assessmentUserId={this.state.assessmentUserId}
          accessorGroupId={this.state.accessorGroupId}
          relationShipId={this.state.relationShipId}
          handleDropdownOptions={this.handleDropdownOptions}
          handleEditModalSubmit={this.handleEditModalSubmit}
          collapseID={this.state.collapseID}
          toggleCollapse={this.toggleCollapse}
        />
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {};

export default withRouter(Dashboard);



// WEBPACK FOOTER //
// ./src/new/Dashboard/index.jsx